
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/transactions",
      function () {
        return require("private-next-pages/docs/transactions/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/transactions"])
      });
    }
  